import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const RegistrationContainer = styled.div`
  padding: 40px;
  .step1-description {
    margin-bottom: 30px;
  }
  .form-row {
    .form-group {
      .date-description ul li {
        line-height: 1.2;
        margin-bottom: 0;
      }
    }
  }
  .e-input-group-icon {
    display: none;
  }

  .e-input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .narration {
    font-size: 15px;
    color: ${colors.dark4};
    margin-bottom: 4px;
  }

  .select-language-error > div {
    border-color: #f00;
  }
  .error-message {
    color: #000082;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
  }

  .primary-author {
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: ${breakpoints.sm}px) {
    padding: 0 18px 60px;
    .step1-description {
      background-color: ${colors.gray};
      margin: 0 -18px;
      padding: 20px;
    }
    .form-row {
      .form-group {
        .date-description {
          margin-top: 20px;
        }
      }
    }

    .primary-author {
      justify-content: flex-start;
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`
